var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchway(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M560 96C568.875 96 576 88.875 576 80V16C576 7.125 568.875 0 560 0H16C7.125 0 0 7.125 0 16V80C0 88.875 7.125 96 16 96H24V496H8C3.578 496 0 499.578 0 504S3.578 512 8 512H192C196.422 512 200 508.422 200 504V328C200 279.469 239.469 240 288 240S376 279.469 376 328V504C376 508.422 379.578 512 384 512H568C572.422 512 576 508.422 576 504S572.422 496 568 496H552V96H560ZM16 80V16H560V80H16ZM536 496H392V328C392 270.656 345.344 224 288 224S184 270.656 184 328V496H40V96H536V496Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchway);
export default __webpack_public_path__ + "static/media/archway.142bfe480073eb64b0430958401f1088.svg";
export { ForwardRef as ReactComponent };